import { useMemo } from "react";
import { object, string, number } from "yup";
import type { BooleanSwitch } from "types";
import { BooleanSwitchValue } from "consts/general";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.HasTerminationHistory]: number()
                .nullable()
                .required(),

            [FormField.TerminationHistoryInput]: string()
                .nullable()
                .when(FormField.HasTerminationHistory, {
                    is: (value: BooleanSwitch) => Object.is(value, BooleanSwitchValue.On),
                    then: validator => validator
                        .required()
                        .trim()
                        .min(10)
                        .max(500)
                        .label('Termination History Input')
                }),

            [FormField.HasCreditLimitPolicy]: number()
                .nullable()
                .required(),

            [FormField.CreditLimitPolicyInput]: string()
                .nullable()
                .when(FormField.HasCreditLimitPolicy, {
                    is: (value: BooleanSwitch) => Object.is(value, BooleanSwitchValue.On),
                    then: validator => validator
                        .required()
                        .trim()
                        .min(10)
                        .max(500)
                        .label('Credit Limit Policy Input')
                }),

            [FormField.FraudToolsInput]: string()
                .nullable()
                .required()
                .trim()
                .min(20)
                .max(600)
                .label('Fraud Tools Input'),

            [FormField.KycProviderInput]: string()
                .nullable()
                .required()
                .trim()
                .min(20)
                .max(600)
                .label('KYC Provider Input'),

            [FormField.RefundChargebackPolicyInput]: string()
                .nullable()
                .required()
                .trim()
                .min(20)
                .max(800)
                .label('Refund and Chargeback Policy Input'),

            [FormField.AdditionalRiskInput]: string()
                .nullable()
                .trim()
                .min(10)
                .max(800)
                .label('Additional Risk Input'),

            [FormField.SecurityFeaturesInput]: string()
                .nullable()
                .required()
                .trim()
                .min(20)
                .max(800)
                .label('Security Features Input'),

            [FormField.HasSsl]: number()
                .nullable()
                .oneOf([BooleanSwitchValue.On, BooleanSwitchValue.Off], 'Select Yes or No')
                .label('Has SSL Certificate')
        })
    ), []);

export default useValidationSchema;
